import React from 'react';
import swal from 'sweetalert';
import moment from 'moment';
import { spmfcloudFunctionUrl } from '../../../actions/salesforces';
import { fetchQueryData } from '../../../utils/sf-request';

export default null;

const sortBasedOnName = (a, b) => {
    if (a === null) a = { Name: '' };
    if (b === null) b = { Name: '' };
    if (a.Name.toLowerCase() > b.Name.toLowerCase()) {
        return 1;
    } else if (a.Name.toLowerCase() < b.Name.toLowerCase()) {
        return -1;
    }

    return 0;
};

export function transferColumn() {
    return [{
        Header: 'Transfer No',
        accessor: 'Name',
    }, {
        accessor: 'Bene_Contact__r',
        Header: 'Beneficiary Name',
        Cell: columnProps => columnProps.value.Name,
        filterMethod: (filter, row) => {
            if (row.Bene_Contact__r.Name.toLowerCase().includes(filter.value.toLowerCase())) return row;
        },
        sortMethod: sortBasedOnName,
    }, {
        Header: 'Transferor',
        accessor: 'Transferor__r',
        Cell: columnProps => columnProps.value.Name,
        filterMethod: (filter, row) => {
            if (row.Transferor__r.Name.toLowerCase().includes(filter.value.toLowerCase())) return row;
        },
        sortMethod: sortBasedOnName,
    }, {
        accessor: 'Transferee__r',
        Header: 'Transferee',
        Cell: columnProps => columnProps.value.Name,
        filterMethod: (filter, row) => {
            if (row.Transferee__r.Name.toLowerCase().includes(filter.value.toLowerCase())) return row;
        },
        sortMethod: sortBasedOnName,
    }, {
        accessor: 'Transfer_Status__c',
        Header: 'Transfer Status',
    }, {
        accessor: 'Request_Date__c',
        Header: 'Request Date',
        Cell: columnProps => moment(columnProps.value).format('DD MMM YYYY'),
        filterMethod: (filter, row) => {
            if (moment(row.Request_Date__c).format('DD MMM YYYY').toLowerCase().indexOf(filter.value.toLowerCase()) !== -1) return row;
        },
    }, {
        accessor: 'Id',
        Header: 'Actions',
        minWidth: 200,
        filterable: false,
        sortable: false,
        Cell: (columnProps) => {
            const buttons = [];
            const transferStatus = columnProps.row.Transfer_Status__c;
            const owner = columnProps.row.Transferor__r.Id === this.props.user.loggedInUser.AccountId;
            const isApprover = this.props.user.loggedInUser.Partner_Authority__c === 'Approver';
            const isVerifier = this.props.user.loggedInUser.Partner_Authority__c === 'Verifier';
            const findSelected = {
                bene: columnProps.row.Bene_Contact__r,
                transferee: columnProps.row.Transferee__r,
            };
            const form = {
                Id: columnProps.row.Id,
                Bene_Contact__c: columnProps.row._original.Bene_Contact__c,
                Transferee__c: columnProps.row.Transferee__r.Id,
                Remarks__c: columnProps.row._original.Remarks__c,
                Effective_Date__c: moment(columnProps.row._original.Effective_Date__c),
                beneficiaryName: columnProps.row.Bene_Contact__r.Name,
                transfereeName: columnProps.row.Transferee__r.Name,
                Transfer_Status__c: columnProps.row.Transfer_Status__c,
            };
            // given different keys to button
            if (transferStatus === 'Planned' && owner) {
                buttons.push(
                    <button
                        className="btn btn-sm btn-primary"
                        key="Edit"
                        onClick={() => this.setState({ editMode: true, showModal: true, form })}
                    >
                        <i className="fa fa-edit" /> Edit
                    </button>,
                    <button
                        className="btn btn-sm btn-success btn-fill"
                        key="Verify"
                        onClick={() => this.changeStatus('Verified by Transferor', columnProps.value)}
                    >
                        <i className="fa fa-check" /> Verify
                    </button>,
                    <button
                        className="btn btn-sm btn-fill btn-danger"
                        key="Cancel"
                        onClick={() => this.changeStatus('Cancelled by Transferor', columnProps.value)}
                    >
                        <i className="fa fa-thumbs-down" /> Cancel
                    </button>,
                );
            } else if (transferStatus === 'Verified by Transferor' && isApprover) {
                buttons.push(
                    <button
                        className="btn btn-sm btn-fill btn-success"
                        key="Approve"
                        onClick={() => this.changeStatus('Approved By Transferor', columnProps.value)}
                    >
                        <i className="fa fa-thumbs-up" /> Approve
                    </button>,
                    <button
                        className="btn btn-sm btn-fill btn-danger"
                        key="Reject"
                        onClick={() => this.changeStatus('Rejected by Transferor approver', columnProps.value)}
                    >
                        <i className="fa fa-thumbs-down" /> Reject
                    </button>,
                );
            } else if (transferStatus === 'Approved by Transferor') {
                buttons.push(
                    <button
                        className="btn btn-default btn-sm"
                        key="CancelTr"
                        onClick={() => this.changeStatus('Cancelled by Transferor', columnProps.value)}
                    >
                        <i className="fa fa-times" /> Cancel
                    </button>,
                    <button
                        className="btn btn-info btn-fill btn-sm"
                        key="Submit"
                        onClick={() => this.changeStatus('Submitted by Transferor', columnProps.value)}
                    >
                        <i className="fa fa-paper-plane" /> Submit
                    </button>,
                );
            } else if (transferStatus === 'Submitted by Transferor' && owner === false) {
                if (isApprover) {
                    buttons.push(
                        <button
                            className="btn btn-success btn-sm btn-fill "
                            key="ApproveTr"
                            onClick={() => this.changeStatus('Approved By Transferee', columnProps.value)}
                        >
                            <i className="fa fa-thumbs-up" /> Approve
                        </button>,
                    );
                }
                buttons.push(
                    <button
                        className="btn btn-success btn-sm"
                        key="VerifyTr"
                        onClick={() => this.changeStatus('Verified by Transferee', columnProps.value)}
                    >
                        <i className="fa fa-check" /> Verify
                    </button>,
                    <button
                        className="btn btn-danger btn-sm btn-fill "
                        key="RejectTr"
                        onClick={() => this.changeStatus('Rejected by Transferee', columnProps.value)}
                    >
                        <i className="fa fa-thumbs-down" /> Reject
                    </button>,
                );
            } else if (transferStatus === 'Verified by Transferee' && isApprover) {
                buttons.push(
                    <button
                        className="btn btn-success btn-sm"
                        key="ApproveTrans"
                        onClick={() => this.changeStatus('Approved by Transferee', columnProps.value)}
                    >
                        <i className="fa fa-check" /> Approve
                    </button>,
                    <button
                        className="btn btn-danger btn-sm btn-fill "
                        key="RejectTrans"
                        onClick={() => this.changeStatus('Rejected by Transferee', columnProps.value)}
                    >
                        <i className="fa fa-thumbs-down" /> Reject
                    </button>,
                );
            }
            return (
                <div className="btn-group" role="group" aria-label="...">
                    {buttons}
                </div>
            );
        },
    }];
}


export const accountColumn = [{
    accessor: 'Name',
    Header: 'Account Name',
}, {
    accessor: 'Phone',
    Header: 'Phone No',
}, {
    accessor: 'Website',
    Header: 'Website',
}, {
    accessor: 'Join_Date__c',
    Header: 'Join Date',
    Cell: columnProps => moment(columnProps.value).format('DD-MMM-YYYY'),
}];
/**
 * Get all transferrer that transferrer equal to loggedInUser
 */
export async function getAllTransfer() {
    // if (this.state.loading) return;
    const query = `Select Id, Name, Bene_Contact__r.Name, Bene_Contact__c, Current_School__c,
        Date_Approved_by_Transferee__c,
        Date_Approved_by_Transferor__c,
        Remarks__c, Request_Date__c, Transferee__r.Name,
        Transferee__r.Id, Transferor__r.Name,
        Transferor__r.Id, Transfer_Status__c, Effective_Date__c
        FROM Transfer__c
        WHERE Transferor__c = '${this.props.user.loggedInUser.AccountId}'
        OR (Transferee__c = '${this.props.user.loggedInUser.AccountId}'AND Transfer_Status__c in ('Submitted by Transferor', 'Verified by Transferee', 'Approved by Transferee', 'Rejected by Transferee'))`;
    this.setState({ loading: true });
    try {
        const result = await fetchQueryData(query, this.props.user.siteToken.hash, this.props.user.key);
        this.setState({ loading: false, data: result.records || [] });
        console.log(result);
    } catch (error) {
        swal({
            text: error.toString(),
            title: 'An error occured',
        });
        this.setState({ loading: false });
    }
}

/**
 * This function need to be binded with main compoentn
 */
export async function createTransfer() {
    if (this.state.loading) return;
    const {
        Id,
        Bene_Contact__c,
        Transferee__c,
        Remarks__c,
        Effective_Date__c,
        Transfer_Status__c,
    } = this.state.form;

    const {
        Partner_Authority__c
    } = this.props.user.loggedInUser;
    this.setState({ loading: true });
    try {
        if (Bene_Contact__c.trim() === '' || Transferee__c.trim() === '' || Remarks__c.trim() === '') {
            throw new Error('Beneficiary name, transferee, and remarks must not be empty');
        }

        const formValue = {
            Bene_Contact__c,
            Transferee__c,
            Remarks__c,
            Effective_Date__c: Effective_Date__c.format('YYYY-MM-DD'),
            Transferor__c: this.props.user.loggedInUser.AccountId,
            Transfer_Status__c: Partner_Authority__c === 'Approver' ? 'Approved by Transferor' : null,
        };
        if (this.state.editMode) {
            formValue.Id = Id;
            formValue.Transfer_Status__c = Transfer_Status__c;
            // Beneficiary and transferee name are uneditable
            delete formValue.Bene_Contact__c;
            delete formValue.Transferor__c;
        }
        const result = await fetch(`${spmfcloudFunctionUrl}/transfer`, {
            mode: 'cors',
            cache: 'no-cache',
            method: this.state.editMode ? 'PUT' : 'POST',
            body: JSON.stringify(formValue),
            headers: {
                'hash-token': this.props.user.siteToken.hash,
                'Content-Type': 'application/json',
            },
        }).then(async (response) => {
            const json = await response.json();
            if (!response.ok) {
                throw new Error(json.message);
            }
            return json;
        });
        await this.componentWillMount();

        this.closeModal();
        this.setState({
            loading: false,
        });

        const successTitle = this.state.editMode ? 'Update transfer record success' : 'Create transfer record success';
        swal({
            text: result.message,
            title: successTitle,
        });
    } catch (error) {
        this.setState({ loading: false });
        const errorTitle = this.state.editMode ? 'Unable to update transfer record' : 'Error when creating transfer record';
        swal({
            text: error.message,
            title: errorTitle,
            dangerMode: true,
        });
    }
}


/**
 * Update a record to salesforce, need to be bind with main component
 * @param {*} id : Termination ID
 * @param {*} status : Status that want to inserted
 */
export async function changeStatus(status, id) {
    if (this.state.loading) return;
    this.setState({ loading: true });
    const updatedData = {
        Id: id,
        Transfer_Status__c: status,
    };
    if (status === 'Approved by Transferor') {
        updatedData.Date_Approved_by_Transferor__c = new Date();
    } else if (status === 'Approved By Transferee') {
        updatedData.Date_Approved_by_Transferee__c = new Date();
    }
    try {
        const result = await fetch(`${spmfcloudFunctionUrl}/sobject/Transfer__c`, {
            mode: 'cors',
            cache: 'no-cache',
            method: 'PATCH',
            body: JSON.stringify(updatedData),
            headers: {
                'hash-token': this.props.user.siteToken.hash,
                'Content-Type': 'application/json',
            },
        }).then((response) => {
            if (!response.ok) throw (new Error(response.message));
            return response.json();
        });
        // using it because sometimes unable to get latest data from salesforce
        setTimeout(() => {
            this.componentWillMount();
        }, 300);
        this.setState({ loading: false });
        swal({
            text: result.message,
            title: 'Transfer status updated successfully.',
        });
    } catch (error) {
        swal({
            text: error.toString(),
            title: 'An error occured when updating status',
        });
        this.setState({ loading: true });
    }
}



//////////////////
// WEBPACK FOOTER
// ./src/components/Portal/Transfer/actions.js
// module id = 997
// module chunks = 0